// ------------------------------------
// Constants
// ------------------------------------
export const NETWORK_POLICIES_GET_REQUEST = "NETWORK_POLICIES_GET_REQUEST";
export const NETWORK_POLICIES_GET_REQUEST_SUCCESS =
  "NETWORK_POLICIES_GET_REQUEST_SUCCESS";
export const NETWORK_POLICIES_GET_REQUEST_FAILURE =
  "NETWORK_POLICIES_GET_REQUEST_FAILURE";
export const NETWORK_POLICIES_GET_RESET = "NETWORK_POLICIES_GET_RESET";

// ------------------------------------
// Actions
// ------------------------------------
export function request(params) {
  return {
    type: NETWORK_POLICIES_GET_REQUEST,
    params,
  };
}

export function requestSuccess(data) {
  return {
    type: NETWORK_POLICIES_GET_REQUEST_SUCCESS,
    data,
  };
}

export function requestFailure(error) {
  return {
    type: NETWORK_POLICIES_GET_REQUEST_FAILURE,
    error,
  };
}

export function reset() {
  return {
    type: NETWORK_POLICIES_GET_RESET,
  };
}
